import { render, staticRenderFns } from "./StartScreen.vue?vue&type=template&id=18966d5b&scoped=true"
import script from "./StartScreen.vue?vue&type=script&lang=js"
export * from "./StartScreen.vue?vue&type=script&lang=js"
import style0 from "@pds/typography/typography.min.css?vue&type=style&index=0&id=18966d5b&prod&scoped=true&lang=css&external"
import style1 from "@pds/button/button.min.css?vue&type=style&index=1&id=18966d5b&prod&scoped=true&lang=css&external"
import style2 from "./StartScreen.vue?vue&type=style&index=2&id=18966d5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18966d5b",
  null
  
)

export default component.exports